import { DefaultError, useMutation, useQuery } from '@tanstack/react-query';
import { useQueryToast } from 'hooks';
import i18next from 'i18next';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { IArtistLight, IArtistResponse, IUpdateArtistDuplicate } from './types';

export const useGetArtistDuplicates = (id: string) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<IArtistLight[], DefaultError>({
    queryKey: ['artist-duplicates', id],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Artist/Duplicates`,
        params: { ArtistId: id },
      });

      return responseHandler(response, {
        groupName: `useGetArtistDuplicates`,
      });
    },
  });
};

export const useUpdateArtistDuplicate = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast(
    'useUpdateArtistDuplicate'
  );
  return useMutation<IArtistResponse, DefaultError, IUpdateArtistDuplicate>({
    mutationFn: async body => {
      loading(
        i18next.t('service-message.update.loading', {
          what: i18next.t('artist.what'),
        })
      );
      const response = await apiClient({
        method: 'PUT',
        url: 'Artist/ReplaceDuplicates',
        body,
      });

      return responseHandler(response, {
        groupName: 'usePostArtist',
      });
    },
    onSuccess: data => {
      success(
        i18next.t('service-message.update.success', {
          what: i18next.t('artist.what'),
        })
      );
    },
    onError: dismiss,
  });
};
